import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "options-error"
};
const _hoisted_2 = {
    key: 1,
    class: "no-options"
};
const _hoisted_3 = { class: "pagination" };
const _hoisted_4 = ["disabled"];
const _hoisted_5 = ["disabled"];
import { ref } from 'vue';
import env from "../services/AppEnv";
import paloma from '../services/PalomaBackend';
import Icon from "./Icon.vue";
import VSelect from 'vue-select';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchFilterEntityChoices',
    props: {
        filter: {}
    },
    emits: [
        'change'
    ],
    setup(__props, { emit: __emit }) {
        const http = paloma.http;
        const props = __props;
        const emit = __emit;
        const model = ref([]);
        const choiceEntities = ref([]);
        const searchQuery = ref('');
        const choicesUrl = ref("url" in props.filter.filter.choices ? props.filter.filter.choices.url : null);
        const choicesPage = ref(null);
        const errorKey = ref(null);
        loadChoices().then(() => {
            const values = Array.isArray(props.filter.value) ? props.filter.value : [];
            values.forEach(id => {
                // search in loaded choices
                const choice = choiceEntities.value.find(c => id === c.id);
                if (choice) {
                    model.value.push(choice);
                }
                else {
                    // load choice for value (id)
                    // HACK: this assumes that the backend supports the "id:XY" notation (works with standard ES-indexed entities)
                    fetchChoices({ query: "id:" + id, page: 0, size: 1, locale: env.locale })
                        .then(data => {
                        const choice = (Array.isArray(data)
                            ? data
                            : data.content).find(c => id === c.id);
                        if (choice) {
                            model.value.push(choice);
                        }
                    });
                }
            });
        });
        function onChange() {
            const data = model.value ? model.value.map(choice => choice.id) : [];
            emit('change', data);
        }
        // TODO debounce?
        function fetchOptions(search, loading) {
            if (!choicesUrl.value) {
                return;
            }
            searchQuery.value = search || '';
            if (choicesPage.value) {
                choicesPage.value.number = 0;
            }
            loading(true);
            loadChoices()
                .finally(() => loading(false));
        }
        function loadChoices() {
            errorKey.value = null;
            const params = {
                query: searchQuery.value,
                page: (choicesPage.value && choicesPage.value.number) || 0,
                size: (choicesPage.value && choicesPage.value.size) || 10,
                locale: env.locale,
            };
            return fetchChoices(params)
                .then(data => {
                if (Array.isArray(data)) {
                    choiceEntities.value = data;
                }
                else {
                    // assume Page<T>
                    choiceEntities.value = data.content;
                    choicesPage.value = data;
                }
            });
        }
        function fetchChoices(params) {
            return http
                .get(choicesUrl.value, {
                params: params,
            })
                .then((response) => {
                return response.data;
            })
                .catch((e) => {
                errorKey.value = e?.response?.status === 403
                    ? 'search.filter.options_forbidden'
                    : 'search.filter.options_unavailable';
                return [];
            });
        }
        function prevPage() {
            choicesPage.value.number--;
            loadChoices();
        }
        function nextPage() {
            choicesPage.value.number++;
            loadChoices();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(VSelect), {
                modelValue: model.value,
                "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                    onChange
                ],
                onSearch: fetchOptions,
                options: choiceEntities.value,
                filterable: false,
                multiple: true,
                "close-on-select": false,
                "deselect-from-dropdown": true,
                onKeydown: [
                    _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => { }, ["exact", "stop"]), ["up"])),
                    _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => { }, ["exact", "stop"]), ["down"]))
                ]
            }, _createSlots({
                option: _withCtx((option) => [
                    _createTextVNode(_toDisplayString(option.name), 1)
                ]),
                "selected-option": _withCtx((option) => [
                    _createTextVNode(_toDisplayString(option.name), 1)
                ]),
                "no-options": _withCtx(() => [
                    (errorKey.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                            _createVNode(Icon, { name: "warning" }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(errorKey.value)), 1)
                        ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('grid.no_search_results')), 1))
                ]),
                _: 2
            }, [
                (choicesPage.value && choicesPage.value.totalPages > 1)
                    ? {
                        name: "list-footer",
                        fn: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("button", {
                                    disabled: !choicesPage.value || choicesPage.value.first,
                                    onClick: _withModifiers(prevPage, ["prevent"]),
                                    href: "",
                                    class: "pagination__btn"
                                }, _toDisplayString(_ctx.$t('prev')), 9, _hoisted_4),
                                _cache[3] || (_cache[3] = _createTextVNode()),
                                _createElementVNode("button", {
                                    disabled: !choicesPage.value || choicesPage.value.last,
                                    onClick: _withModifiers(nextPage, ["prevent"]),
                                    href: "",
                                    class: "pagination__btn"
                                }, _toDisplayString(_ctx.$t('next')), 9, _hoisted_5)
                            ])
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032, ["modelValue", "options"]));
        };
    }
});
